import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {useSyncEvent} from '@containers/hooks'
import {Feedback} from '@extensions/feedback'
import {MenuButtonPage} from '../components/menu-button-page'
import {MenuIconButtonPage} from '../components/menu-icon-button-page'
import {feedbackPage} from '../constants'
import {useMainMenuStore} from '../main-menu-store'

export const FeedbackMenuItem = observer(() => {
  const [state] = useMainMenuStore()
  const [newCount, setNewCount] = useState(Feedback.getNewItemCount())
  const {paymentStatus, readonly} = state
  useSyncEvent('news', {filter: '*', debounceTime: 1000}, () => {
    setNewCount(Feedback.getNewItemCount())
  })

  const noFeedbackVisible =
    readonly || (paymentStatus && paymentStatus.tariff === 'standalone')
  if (noFeedbackVisible) {
    return null
  }

  const notificationShown = newCount > 0
  const count = notificationShown ? `+${newCount}` : ''

  if (state.menuOpen) {
    return (
      <MenuButtonPage
        page={feedbackPage}
        text={Lang.msg.menu.supportPage}
        icon={'IconLifebuoy'}
        count={count}
        countMarked={notificationShown}
      />
    )
  }

  return (
    <MenuIconButtonPage
      icon="IconLifebuoy"
      notification={notificationShown}
      page={feedbackPage}
      hint={Lang.msg.menu.supportPage}
    />
  )
})
